{#if type === 'section'}
    <section id="{id}" role="tabpanel" aria-labelledby="{labelledBy}" class="prom-tabs__content" tabindex="-1">
        <svelte:element this={headingLevel}>
            {title}
        </svelte:element>
        <slot></slot>
    </section>
{:else}
    <div id="{id}" role="tabpanel" aria-labelledby="{labelledBy}" class="prom-tabs__content" tabindex="-1">
        <slot></slot>
    </div>
{/if}

<script>
    /** @type {string} */
    export let id = '';
    /** @type {'h2'|'h3'|'h4'|'h5'|'h6'}*/
    export let headingLevel = 'h3';
    /** @type {string} */
    export let title = '';
    /** @type {string} */0
    export let labelledBy = '';
    /** @type {'section'|'container'} */
    export let type = "section";
</script>
